import { CreateYardBlockRequest, UpdateYardBlockRequest, YardBlockDto } from '@yard/app/api';
import { IYardBlockFormData } from '../models/yard-setup.model';

export const mapYardBlockFormDataToCreateCommand = (
  data: IYardBlockFormData,
  position?: { x: number; y: number },
) => {
  const command: CreateYardBlockRequest = {
    name: data.name,
    maxBays: data.maxBays,
    maxRows: data.maxRows,
    maxTiers: data.maxTiers,
    rowNamingSchema: data.rowNamingSchema,
    bayNamingSchema: data.bayNamingSchema,
    equipmentTypes: data.equipmentTypes ?? [],
    acceptedLengths: data.acceptedLengths ?? [],
    position: {
      x: Math.round(position?.x ?? 0),
      y: Math.round(position?.y ?? 0),
      rotation: 0,
    },
    description: data.description,
  }

  return command
}

export const mapYardBlockFormDataToUpdateCommand = (
  editingData: YardBlockDto,
  data: IYardBlockFormData,
) => {
  const command: UpdateYardBlockRequest = {
    id: editingData.id,
    name: data.name || editingData.name,
    maxBays: data.maxBays || editingData.maxBays,
    maxRows: data.maxRows || editingData.maxRows,
    maxTiers: data.maxTiers || editingData.maxTiers,
    acceptedLengths: data.acceptedLengths ?? editingData.acceptedLengths ?? [],
    description: data.description || editingData.description,
  }

  return command
}
